package com.milta.feature.imports.domain.entity

/**
 * Response of `POST /api/v1/imports/pdf` (MIL-26) — a single synchronous call, no session, no
 * server-side attempt tracking. Deliberately a distinct type from [ImportResult] (MIL-29's
 * Photo/Pdf/Spreadsheet flow, one result per session): this endpoint always returns an array of
 * rows, each with its own [ExtractedDelivery.tempId]/[ExtractedDelivery.missingFields].
 */
data class ImportPdfResult(
    val totalExtracted: Int,
    val deliveries: List<ExtractedDelivery>,
)
